export default {
    noticelog:{
        // 日志类型
        log_email:"邮件日志",
        log_sms:"短信日志",
        log_voice:"语音日志",

        email:"电子邮箱",
        type:"类型",
        send_status:"发送状态",
        mail_content:"邮件内容",
        sms_content:"短信内容",
        send_time:"发送时间",
        result:"返回结果",
        voice_content:"语音内容",

        // 邮件发送状态
        send_success:"发送成功",
        send_fail:"发送失败",

        //类型
        type_alarm:"报警",
        type_captcha:"验证码",
    }
}